import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tippy";
import { isMobile } from "helpers/Mobile";
import Icon from "components/MainApp/atoms/Icon/icon.jsx";
import CopyIcon from "assets/images/copy.png";

import { copyToClipboard } from "helpers/utils/copy";

import styles from "./AppTableItem.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

const statusMap = {
  INT: i18n.t("integrated"),
  NOT: i18n.t("not.integrated"),
  PEN: i18n.t("pending.integration"),
};

const AppTableItem = ({ app, handleClick }) => {
  const columns = ["logo", "name", "client_id", "client_secret", "status"];

  const copyValue = (value) => { };

  const renderPill = (status) => {
    return (
      <div className={styles["app-table-pill-container"]}>
        <div className={`${styles["app-table-pill"]} ${styles[status.toLowerCase()]}`}>
          <p>{statusMap[status]}</p>
        </div>
      </div>
    );
  };

  const renderColumn = (key) => {
    return (
      <div
        className={`${styles[`app-table-item-${key}`]} ${styles["app-table-item"]}`}
        data-app-id={key}
        onClick={() => handleClick(app.id)}
        key={key}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {key === "status" ? statusMap[app[key]] : app[key]}
            </div>
          }
          followCursor={true}
          position="left"
          offset={25}
          disabled={["logo", "client_secret"].includes(key)}
        >
          {key === "logo" && <img src={app.logo} />}
          {key === "name" && <p>{app[key]}</p>}
          {key === "client_id" && <p>{app[key]}</p>}
          {key === "client_secret" && <p>**********************************</p>}
          {key === "status" && <>{renderPill(app[key])}</>}
        </Tooltip>
        {/* {key === "client_id" && <div className="icon"><Icon name="copy" heigth={20} width={20} fill={"#3C7AF5"} /></div> }
        {key === "client_secret" && <div className="icon"><Icon name="copy" heigth={20} width={20} fill={"#3C7AF5"} /></div> } */}

        {key === "client_id" && (
          <div
            className={styles["icon"]}
            onClick={(e) => {
              e.stopPropagation();
              copyToClipboard(app[key]);
            }}
          >
            <img src={CopyIcon} />
          </div>
        )}
        {key === "client_secret" && (
          <div
            className={styles["icon"]}
            onClick={(e) => {
              e.stopPropagation();
              copyToClipboard(app[key]);
            }}
          >
            <img src={CopyIcon} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={styles["app-table-item-wrapper"]}
      data-automation-id={styles["app-item-wrapper"]}
    >
      {!isMobile && (
        <div className={styles["app-table-item-container"]} data-automation-id="app-item">
          {columns.map((column_key) => {
            return renderColumn(column_key);
          })}

          <div
            className={`${styles["app-table-item-scopes"]} ${styles["app-table-item"]}`}
            data-automation-id="app-scopes"
            data-app-id={app.id}
            onClick={() => handleClick(app.id)}
            key={"button"}
          >
            <Icon name="edit2" heigth={20} width={20} fill={"#3C7AF5"} />
          </div>
          <div
            className={`${styles["app-table-item-button"]} ${styles["app-table-item"]}`}
            data-automation-id="app-button"
            data-app-id={app.id}
            onClick={() => handleClick(app.id)}
            key={"button-2"}
          >
            <i className={styles["icon-chevron"]}></i>
          </div>
        </div>
      )}
      {isMobile && (
        <div className={styles["app-table-item-container-mobile"]} onClick={() => handleClick(app.id)} >
          <div className={styles["app-table-item-row-mobile"]}>
            <div className={styles["app-logo"]}>
              <img src={app.logo} />
            </div>
            <div className={styles["app-pill"]}>{renderPill(app.status)}</div>
          </div>
          <div className={styles["app-table-item-row-mobile"]}>
            <div className={styles["app-name"]}>{app.name}</div>
            <div className={styles["app-edit"]}>
              <div className={styles["icon"]} onClick={() => handleClick(app.id)} >
                <Icon name="edit2" heigth={15} width={15} fill={"#3C7AF5"} />
              </div>
            </div>
          </div>
          <div className={styles["app-table-item-row-mobile"]}>
            <div className={`${styles["app-client_id"]} ${styles["app-table-item-col"]}`}>
              <p className={styles["title"]}>{capitalize(i18n.t("client.id"))}</p>
              <p className={styles["value"]}>{app.client_id}</p>
            </div>
            <div className={styles["app-copy"]}>
              <img
                src={CopyIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(app.client_id);
                }}
              />
            </div>
          </div>
          <div className={styles["app-table-item-row-mobile"]}>
            <div className={`${styles["app-client-secret"]} ${styles["app-table-item-col"]}`}>
              <p className={styles["title"]}>{capitalize(i18n.t("secret.client"))}</p>
              <p className={styles["value"]}>**********************************</p>
            </div>
            <div className={styles["app-copy"]}>
              <img
                src={CopyIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(app.client_secret);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppTableItem;
